import {
  APP_LOADING_BEGIN,
  APP_LOADING_END,
  TOGGLE_COLLAPSED,
  CHANGE_HEADER_TITLE,
  UPDATE_LINK_POLICY,
  UPDATE_LINK_LGPD,
} from '../actiontypes/app';

export const beginLoadingData = () => async (dispatch) => {
  dispatch({ type: APP_LOADING_BEGIN });
};

export const endLoadingData = () => async (dispatch) => {
  dispatch({ type: APP_LOADING_END });
};

export const toggleMenuCollapsed = () => async (dispatch) => {
  dispatch({ type: TOGGLE_COLLAPSED });
};

export const changeHeaderTitle = (headerTitle) => async (dispatch) => {
  dispatch({ type: CHANGE_HEADER_TITLE, headerTitle });
};

export const updateLinkPolicyAndCookiesUrl = (link) => async (dispatch) => {
  dispatch({ type: UPDATE_LINK_POLICY, link });
};

export const updateLinkLGPD = (link) => async (dispatch) => {
  dispatch({ type: UPDATE_LINK_LGPD, link });
};
